// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Megamenu extends WebComponent {
	didMount() {
		const { currentId, parentId } = this.props;

		if (currentId || parentId) {
			this.getStaticActiveItem(currentId, parentId);
		}
		else {
			this.getActiveItemFromTrack2Path();
		}
	}

	// gets activeItem from track2path
	getActiveItemFromTrack2Path() {
		let activeItemUrl;

		const activeTrackItem = document.querySelector('.track2path__list .track2path__item:nth-child(2)');

		if (activeTrackItem) {
			const activeTrackLink = activeTrackItem.querySelector('a');

			if (activeTrackLink) {
				activeItemUrl = activeTrackItem.querySelector('a').href;
			}
			else {
				activeItemUrl = activeTrackItem.querySelector('meta[itemprop=item]').content;
			}
		}

		if (activeItemUrl) {
			const result = new URL(activeItemUrl).pathname;
			const activeItem = this.element.querySelector(`a[href="${result}"]`);
			if (activeItem) {
				activeItem.parentNode.classList.add('active');
			}
		}
	}
	getStaticActiveItem(currentId, parentId) {
		const activeItem = this.element.querySelector(`.main-menu__item[data-item-id="${currentId}"]`) || this.element.querySelector(`.main-menu__item[data-item-id="${parentId}"]`);
		if (activeItem) {
			activeItem.classList.add('active');
		}
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Megamenu.js